import React from "react";
import { ColumnDef } from "@tanstack/react-table";

export const deliveryChargeColumns = (): ColumnDef<any, any>[] => [
  {
    header: "Charge ID",
    accessorKey: "id",
    cell: ({ row }) => `CHG${String(row.original.id).padStart(3, "0")}`,
  },
  { header: "Slot Code", accessorKey: "slotcode" },
  { header: "Slot Name", accessorKey: "slotname" },
  { header: "Type", accessorKey: "charge_type" },
  {
    header: "Amount Range",
    accessorKey: "min_amount",
    cell: ({ row }) => {
      const { min_amount, max_amount } = row.original;
      return `${min_amount} - ${max_amount}`;
    },
  },
  {
    header: "Charge",
    accessorKey: "charge_value",
    cell: ({ row }) => row.original.charge_value,
  },
  {
    header: "Status",
    accessorKey: "status",
    cell: ({ getValue }) => {
      const value = getValue<string>() || "";
      const lowerVal = value.toLowerCase();
      const statusColor = lowerVal === "active" ? "#159E3A" : "#A65F00";
      return (
        <span
          style={{
            display: "inline-block",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: "500",
            color: statusColor,
            border: `1px solid ${statusColor}`,
            textTransform: "capitalize",
          }}
        >
          {value || "N/A"}
        </span>
      );
    },
  },
];

const statusColors: Record<string, { color: string; bg: string }> = {
  "in-progress": { color: "#1d8ef8", bg: "#e6f3ff" },
  "in progress": { color: "#1d8ef8", bg: "#e6f3ff" },
  accepted: { color: "#0fa958", bg: "#e7f6ed" },
  scheduled: { color: "#1d8ef8", bg: "#e6f3ff" },
  delivered: { color: "#0fa958", bg: "#e7f6ed" },
  cancelled: { color: "#d83a3a", bg: "#fdecec" },
  pending: { color: "#ff9c07", bg: "#fff3dd" },
};

export const getStatusStyle = (status?: string) => {
  if (!status) return { color: "#6c757d", bg: "#f1f1f1" };
  const key = status.toLowerCase();
  return statusColors[key] || { color: "#6c757d", bg: "#f1f1f1" };
};

export const formatDeliveryDate = (dateStr?: string) => {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

